module.exports = __webpack_public_path__ + "static/img/kefu_img.f58b272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kefu_img.png
// module id = 9T3q
// module chunks = 1